import { ApiHttpService } from '../ApiHttpService';
import { FinancingSerializer } from '../serializers/FinancingSerializer';
import { Financing } from '../../models/Financing';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const PRODUCT_FINANCING_PATH = 'articulos/Financiacion';

class FinancingController {
  static async find(id, amount) {
    const params = ParamsHelper.createQueryParams({
      artId: id,
      entrega: amount,
    });
    const response = await ApiHttpService.get(`${PRODUCT_FINANCING_PATH}${params}`);
    const deSerializedData = FinancingSerializer.deSerialize(response.data);
    return new Financing(deSerializedData);
  }
}

export { FinancingController };



// WEBPACK FOOTER //
// ./src/networking/controllers/FinancingController.js